import React from "react"

import { Tooltip } from "~/ui-rtk/components/ui/common"
import { InfoSvg } from "~/ui-rtk/components/ui/svg/essentials"

type KeywordsTooltipProps = {
  content: string
}

const KeywordsTooltip: React.FC<KeywordsTooltipProps> = ({ content: text }) => (
  <Tooltip
    text={text}
    classes={{
      wrapper: "z-10",
      text: "text-3 font-400",
      triangle: "border-basic-blue bg-white",
      container: "bg-white border border-basic-blue",
    }}
  >
    <InfoSvg fill="basic.black" cursor="pointer" />
  </Tooltip>
)

export default KeywordsTooltip
